import { useContext, useEffect, useState } from "react";
import { AuthData } from "../../hooks/api/apiData";
import useApi from "../../hooks/api/useApi";
import AuthContext from "../../store/auth/AuthContextProvider";
import { ArrowLeft, Eye, EyeOff, ListChecks, Lock, Mail } from "lucide-react";
import { LoginBodyDto } from '../../../../common/DTOs/auth'


const Login = () => {
    const { globalLogInDispatch } = useContext(AuthContext);
    const [authData, setAuthData] = useState<AuthData>();
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { request, setError } = useApi();
    useEffect(() => {
        if (authData && !authData.message) {
            globalLogInDispatch({
                authToken: authData.payload.token,
                userId: authData.payload.user.id.toString(),
                name: authData.payload.user.firstName,
                username: authData.payload.user.username,
                roles: authData.payload.user.roles,
                groups: authData.payload.groups,
            });
        }
    }, [authData, globalLogInDispatch]);
    const body: LoginBodyDto = {
        username,
        password,

    }
    const handleSubmit = async (event: React.FormEvent) => {
        setIsLoading(true)
        event.preventDefault();
        try {
            const params = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            };
            const endpoint = `/auth/login`
            await request(endpoint, params, setAuthData, (error: Error) => {
                setAlertMessage(error.message)
                setIsLoading(false)
            });



        } catch (error: any) {
            setIsLoading(false)
            setError(error.message || error);
        }
    };

    return (
        <section
            style={{
                background: `linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 50%, #f5f0ff 100%)`,
                padding: "80px 24px 90px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* subtle grid pattern */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `
                        linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)
                    `,
                    backgroundSize: "48px 48px",
                    pointerEvents: "none",
                }}
            />
            <div className="min-h-screen flex flex-col items-center justify-center p-6  relative overflow-hidden">
                {/* Background decoration */}
                {/* <div className="absolute top-[-20%] left-[-20%] w-[500px] h-[500px] rounded-full bg-white/20 blur-3xl" /> */}
                {/* <div className="absolute bottom-[-20%] right-[-20%] w-[500px] h-[500px] rounded-full bg-blue-900/20 blur-3xl" /> */}

                <div className="w-full max-w-sm bg-white/90 backdrop-blur-xl rounded-[2.5rem] p-8 shadow-2xl animate-in fade-in zoom-in-95 duration-500">
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-blue-600 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-lg shadow-blue-300">
                            <ListChecks className="text-white w-8 h-8" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-800">خوش آمدید</h1>
                        <p className="text-gray-500 text-sm mt-1">برای دسترسی به پورتال وارد شوید</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">نام کاربری</label>
                            <div className="relative">
                                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="نام کاربری"
                                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">رمز عبور</label>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    className="w-full pl-12 pr-12 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                >
                                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-end">
                            <button type="button" className="text-xs font-semibold text-blue-600 hover:text-blue-700">
                                رمز خود را فراموش کرده اید؟
                            </button>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-4 rounded-2xl bg-blue-600 text-white font-bold text-lg shadow-lg shadow-blue-200 hover:bg-blue-700 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
                        >
                            {isLoading ? (
                                <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            ) : (
                                <>ورود <ArrowLeft size={20} /></>
                            )}
                        </button>
                    </form>
                    
                <div className="mt-8 text-center">
                    <p className="text-gray-500 text-sm">
                        حساب کاربری ندارید{' '}
                        <a href="/register" className="font-bold text-blue-600 hover:text-blue-700">
                            ایجاد حساب کاربری
                        </a>
                    </p>
                </div>
                </div>
            </div>
        </section>
    );
};

export default Login;
